export default __webpack_public_path__ + "static/media/ExitButtonImage.47a89cfe.svg";